import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'

const ContactBanner = ({ title, site }) => {
  const siteThemes = {
    advisor: {
      backgroundColor: 'u-bgColorBrandLight',
      css: 'u-textSizeMsrp1 u-textColorWhite',
    },
    investor: {
      backgroundColor: 'u-bgColorBrandDarker',
      css: 'u-textColorWhite u-textBold',
    },
    institutional: {
      backgroundColor: 'u-bgColorBrandExtraLight',
      css: 'u-textColorBrandDarker',
    },
  }[site]
  return (
    title && (
      <div className="Footer-contactContainer">
        <div className={siteThemes.backgroundColor}>
          <div className="u-sizeConstrained u-paddingVert4gu">
            <p
              id="Footer-focusHeader"
              className={`u-flex u-flexAlignItemsCenter u-textSecondary u-textSizeMsrp1 ${siteThemes.css}`}
              aria-level="3"
            >
              <span className="Icon--material u-textSizeMsrp2 u-marginRight1gu">
                phone_outline
              </span>
              {title}
            </p>
          </div>
        </div>
      </div>
    )
  )
}

export default function FooterContactBanner(props) {
  return (
    <ErrorBoundary
      fallback={() =>
        !isProduction() ? <p>Erorr in ContactBanner component</p> : null
      }
    >
      <ContactBanner {...props}></ContactBanner>
    </ErrorBoundary>
  )
}
